module.exports = __webpack_public_path__ + "img/icons-error-gray.2ac1a3fa.svg";